import { CustomsSourceSystem, IDMSExportHVSyncResponseCode, IDMSHVSyncResponseCode, NlAesMessageType, NlDmsMessageType } from '../enums';

export const DUPLICATE_LRN_ERROR_CODES = [
  'BE0001', // BE IDMS high value (import)
  'BE0012', // BE AES (export)
  'DMS328AA', // NL DMS / NL AES, both IM and EX
] as const;

export const DUPLICATE_LRN_SOURCE_SYSTEMS = [
  CustomsSourceSystem.IDMS_HV,
  CustomsSourceSystem.IDMS_EXPORT,
  CustomsSourceSystem.NL_DECO_HV,
  CustomsSourceSystem.NL_DECO_AES,
] as const;

export const DUPLICATE_LRN_MESSAGE_CODES = [
  IDMSHVSyncResponseCode.REJECTED,
  IDMSExportHVSyncResponseCode.REJECTED,
  NlDmsMessageType.CC456A,
  NlAesMessageType.CC556C,
  NlDmsMessageType.XMLCNT,
] as const;
